module.exports = __webpack_public_path__ + "static/media/images.763f444a.png";